import { render, staticRenderFns } from "./testMembershipDetail.vue?vue&type=template&id=5b363ccc&scoped=true&"
import script from "./testMembershipDetail.vue?vue&type=script&lang=js&"
export * from "./testMembershipDetail.vue?vue&type=script&lang=js&"
import style0 from "./testMembershipDetail.vue?vue&type=style&index=0&id=5b363ccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b363ccc",
  null
  
)

export default component.exports